import { JobRatingAPI } from './API'
import {
  GetJobRatingStatusRequest,
  SubmitProRatingRequest,
} from '@taxfyle/api-internal/internal/job_rating_pb'
import { JobRatingStatus, mapToJobRatingStatus } from './dtos'

export default class JobRatingsStore {
  constructor(private jobRatingApi: JobRatingAPI) {}

  getJobRatingStatus = async (jobId: string): Promise<JobRatingStatus> => {
    const request = new GetJobRatingStatusRequest().setJobId(jobId)

    return await this.jobRatingApi
      .getJobRatingStatus(request)
      .then((result) => mapToJobRatingStatus(result.toObject()))
  }

  submitProRating = async (
    jobId: string,
    rating: number,
    proPublicId: string,
    comment: string
  ) => {
    const request = new SubmitProRatingRequest()
      .setJobId(jobId)
      .setRating(rating)
      .setComment(comment)
      .setProviderUserPublicId(proPublicId)

    return await this.jobRatingApi.submitProRating(request)
  }
}
